import AvApi from '@availity/api-axios';
import { getDeveloperHubPublicApiUrl } from '../config';

export interface Guide {
  name: string;
  content: string;
}

class GuidesApi extends AvApi {
  constructor() {
    super({
      url: getDeveloperHubPublicApiUrl('v1/guides'),
      api: false,
      withCredentials: false,
      sessionBust: false,
    });
  }

  getGuides(): Promise<Guide[]> {
    return this.query({}).then((res) => res.data.guides || []);
  }
}

export default new GuidesApi();
